import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaPhoneAlt,
  FaYoutube,
} from "react-icons/fa";
import { IoIosMail } from "react-icons/io";

import whitelogo from "../assets/img/logowhite.svg";
import { Link } from "react-router-dom";
import SeoLinks from "./SeoLinks";
import LocationLinks from "./LocationLinks";
import PuneLinks from "./PuneLinks";

const Footer = () => {
  return (
    <section className="section-footer">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div>
              <img src={whitelogo} className="img-fluid" alt="" />
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-5">
            <div>
              <p className="footer-heading">How We May Help You?</p>
              <p className="contact-footer-txt">
                <FaPhoneAlt />
                <Link target="_blank" to="tel:8108888168">
                  8108888168
                </Link>
              </p>
              <p className="contact-footer-txt">
                <IoIosMail />
                <Link target="_blank" to="mailto:homesdekho5@gmail.com">
                  homesdekho5@gmail.com
                </Link>
              </p>
            </div>
          </div>
          <div className="col-md-7">
            <div>
              <p className="footer-heading">Follow Us</p>
              <ul className="social-media-ul">
                <li className="social-media-li">
                  <Link
                    to="https://www.facebook.com/share/1EmUDddP4Q/?mibextid=LQQJ4d"
                    target="_blank"
                  >
                    <FaFacebook />
                  </Link>
                </li>
                <li className="social-media-li">
                  <Link
                    to="https://www.instagram.com/regnum_group?igsh=bXZxOXo5NXh6OGJj"
                    target="_blank"
                  >
                    <FaInstagram />
                  </Link>
                </li>
                <li className="social-media-li">
                  <Link
                    to="https://youtube.com/@homesdekho-pvt-ltd?si=CudtbX3A6Pko-q1T"
                    target="_blank"
                  >
                    <FaYoutube />
                  </Link>
                </li>
                <li className="social-media-li">
                  <Link
                    to="https://www.linkedin.com/company/regnumgroup/"
                    target="_blank"
                  >
                    <FaLinkedin />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-5">
            <div>
              <p className="footer-heading">Our Office</p>
              <p className="contact-footer-txt">
                6A/6B, 2nd Floor, Above IDBI Bank, Well Worth CHS, Mulund West
                400080
              </p>
            </div>
          </div>
          <div className="col-md-7">
            <div>
              <p className="footer-heading">Quick Links</p>
              <ul className="social-media-ul">
                <li className="social-media-li">
                  <Link to="/privacy-policy" target="_blank">
                    Privacy Policy
                  </Link>
                </li>
                <li className="social-media-li">
                  <Link to="/terms-of-use" target="_blank">
                    Terms of Use
                  </Link>
                </li>
                <li className="social-media-li">
                  <Link to="disclaimer" target="_blank">
                    Disclaimer
                  </Link>
                </li>
                <li className="social-media-li">
                  <Link to="emi-calculator" target="_blank">
                    EMI Calculator
                  </Link>
                </li>
                <li className="social-media-li">
                  <Link to="blogs" target="_blank">
                    Blog
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          {/* <div className="col-md-12">
            <div
              className="accordion accordion-flush"
              id="accordionFlushExample"
            >
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseOne"
                    aria-expanded="false"
                    aria-controls="flush-collapseOne"
                  >
                    <p className="footer-heading-accordion">
                      What Is Homes Dekho?
                    </p>
                  </button>
                </h2>
                <div
                  id="flush-collapseOne"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    <p>
                      Homes Dekho is a new way to buy home. In a world where
                      facts are chosen to suit interpretations, our algorithms
                      offer accurate recommendations by sifting through vast
                      knowledge banks comprising real time market data and
                      historical decisions of many home buyers, curated by
                      industry experts. Homes Dekho, for every home buyer, is a
                      way to go from 'I feel' to 'I know', at no extra cost.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className="col-md-12">
            <div>
              <p className="footer-heading">Properties in Mumbai</p>
              <p className="footer-subheading">Mumbai property</p>
            </div>
            <SeoLinks />
          </div>
          <div className="col-md-12">
            <div>
              <p className="footer-heading">Properties in Pune</p>
              <p className="footer-subheading">Pune property</p>
            </div>
            <PuneLinks />
          </div>
          <div className="col-md-12">
            <div>
              <p className="footer-heading">Popular Flat Searches</p>
            </div>
            <LocationLinks />
          </div>

          <div className="col-md-6">
            <div>
              <p className="copyright-footer-txt">
                &copy; {new Date().getFullYear()} HomesDekho.com. All Rights
                Reserved.
              </p>
            </div>
          </div>
          <div className="col-md-6">
            <div>
              <p className="design-footer-txt">
                Designed & Maintained by &nbsp;
                <Link
                  to="https://www.tgconnectmediaservices.com/"
                  target="_blank"
                >
                  TG Connect Media Services.
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
